/**
 * This symbol is used to create SVG line/shape/pattern
 * ## Behaviors:
 * - 'line': auto scale height of horizontal repeated shapes.
 *  + only works with horizontal direction to save bytes & avoid complicated svg making
 * - 'shape': stretch to 100% width and height.
 * - 'pattern': shape size based on user input.
 */
import * as React from 'react';
import AnimatableDiv from './AnimatableDiv';
import { mouseEventProps } from './mouseEventProps';
import { joinClass } from './symbolUtils';
export const Svg = ({ conditionalState, hoverAnimation, innerRef, inEditor, symbol, timelineRefId, }) => {
    const { attributes, position, styles } = conditionalState;
    const { svgType, color, svgCode, size, stretch } = attributes;
    const { clickClass, mouseEventStyles, onClick } = mouseEventProps(symbol, inEditor, hoverAnimation);
    const className = joinClass(symbol.id, conditionalState.id, clickClass);
    const { code, outerSvgSize, patternStyles } = buildSvgAttrs(svgType, svgCode, color, size, stretch // stretchability for `shape`
    );
    // Id must be unique for SVG to render specifically for the layout
    const svgId = `s_${conditionalState.id}`;
    return (React.createElement(AnimatableDiv, { className: className, hoverAnimation: hoverAnimation, id: timelineRefId, innerRef: innerRef, onClick: onClick, position: position, style: Object.assign(Object.assign(Object.assign({}, mouseEventStyles), styles), { display: 'flex', overflow: 'hidden', alignItems: 'center' }), inEditor: inEditor }, svgType !== 'shape' ? (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "100%", height: outerSvgSize },
        React.createElement("defs", null,
            React.createElement("pattern", Object.assign({ id: svgId, dangerouslySetInnerHTML: { __html: code } }, patternStyles))),
        React.createElement("rect", { fill: `url(#${svgId})`, width: "100%", height: "100%" }))) : (React.createElement("div", { style: { width: '100%', height: '100%' }, dangerouslySetInnerHTML: { __html: code } }))));
};
export default Svg;
export const buildSvgAttrs = (type, svgCode, color, size, stretch) => {
    // default is `line` values
    let innerSvgSize = size;
    let outerSvgSize = size;
    let preserveAspectRatio = '';
    // Shape: only innerSvgSize & preserveAspectRatio are used
    if (type === 'shape') {
        innerSvgSize = '100%';
        if (stretch === '1') {
            preserveAspectRatio = 'preserveAspectRatio="none"';
        }
    }
    else if (type === 'pattern') {
        outerSvgSize = '100%';
    }
    return {
        outerSvgSize,
        patternStyles: {
            width: size,
            height: size,
            patternUnits: 'userSpaceOnUse',
        },
        code: svgCode
            .replace(/currentcolor/gi, color)
            .replace('<svg', `<svg width="${innerSvgSize}" height="${innerSvgSize}" ${preserveAspectRatio}`),
    };
};
